import React from "react";

interface LoadingBarProps {
  active: boolean;
}

export default function LoadingBar({ active }: LoadingBarProps) {
  return (
    <div
      className={`fixed top-0 left-0 h-1 bg-purple-500 transition-all duration-300 ${
        active ? "w-full opacity-100" : "w-0 opacity-0"
      }`}
      style={{ zIndex: 9999 }}
    />
  );
}
